/* eslint-disable no-console */
import { AxiosError } from 'axios';
import fetch, { fetchUser } from 'components/libs/fetch';
import { API_PATHS } from 'constant/api';

import { ATTENDANCE, TABLE_PAGE_INIT, TABLE_PAGE_SIZE } from './constant';

const postLogin = async ({
  body,
}: {
  body: {
    username: string;
    password: string;
  };
}): Promise<boolean> => {
  try {
    console.log('LOGIN ->', body);
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(false);
  }
};

const getUser = async (accessToken?: string): Promise<object> => {
  try {
    console.log('accessToken ->', accessToken);
    return Promise.resolve({ name: 'TARO' });
  } catch (error) {
    return Promise.reject(error);
  }
};

const postAuthLogin = async (body: IAuthConfigQuery) => {
  const api = fetch();
  try {
    const { data } = await api.post(API_PATHS.auth, {
      ...body,
      typeLogin: ATTENDANCE,
    });
    return data;
  } catch (error) {
    console.log(error);
  }
};

const postSettingDb = async (body: ISettingQuery, accessToken?: string) => {
  const api = fetchUser(accessToken);
  try {
    const { data } = await api.post(API_PATHS.setting, body);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const postAbsenceTime = async (body: IAbsenceTimeQuery) => {
  const api = fetchUser();
  try {
    const { data } = await api.post(API_PATHS.absenceTime, body);
    return data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

const getAbsenceTime = async () => {
  const api = fetchUser();
  try {
    const { data } = await api.get(API_PATHS.absenceTime);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const postThreshold = async (body: IThresHoldQuery) => {
  const api = fetchUser();
  try {
    const { data } = await api.post(API_PATHS.threshold, body);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getThreshold = async () => {
  const api = fetchUser();
  try {
    const { data } = await api.get(API_PATHS.threshold);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getDatabases = async (body: IGetDatabaseQuery) => {
  const api = fetchUser();
  const { ...query } = body;

  const searchQuery: Record<string, string> = {
    page: query.page ?? TABLE_PAGE_INIT,
    pageSize: query.pageSize ?? TABLE_PAGE_SIZE,
  };
  if (query.name) searchQuery.name = query.name;
  const params = new URLSearchParams(searchQuery).toString();

  try {
    const { data } = await api.get(API_PATHS.database + '?' + params);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getFaceIds = async () => {
  const api = fetchUser();
  try {
    const { data } = await api.get(API_PATHS.faceIds);
    return data.data;
  } catch (error) {
    console.log(error);
  }
};

const healthFaceDb = async (url: string) => {
  const api = fetch();
  try {
    const { data } = await api.post(API_PATHS.healthFaceDb, { url });
    return data.data.status;
  } catch (error) {
    console.log(error);
  }
};


export interface ISystemErrorResponse {
  response_message?: string;
  response_code?: string;
}

export type FetchErrorData = AxiosError<ISystemErrorResponse>;

export {
  getAbsenceTime,
  getDatabases,
  getFaceIds,
  getThreshold,
  getUser,
  postAbsenceTime,
  postAuthLogin,
  postLogin,
  postSettingDb,
  postThreshold,
  healthFaceDb
};
